import { useContext } from 'react';
import {
  useFeature as useGrowthbookFeature,
  useGrowthBook,
  type FeatureResult,
} from '@growthbook/growthbook-react';
import { GrowthbookReadyContext } from './GrowthbookWrapper';

export interface UseFeatureReturn extends FeatureResult {
  loading: boolean;
}

export function useFeature(id: string): UseFeatureReturn {
  const gb = useGrowthBook();
  const feature = useGrowthbookFeature(id);
  const isReady = useContext(GrowthbookReadyContext);

  return {
    ...feature,
    loading: !isReady,
  };
}
